var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5C11 6.104 10.104 7 9 7C7.896 7 7 6.104 7 5C7 3.896 7.896 3 9 3C10.104 3 11 3.896 11 5ZM7 12C7 10.896 7.896 10 9 10C10.104 10 11 10.896 11 12C11 13.104 10.104 14 9 14C7.896 14 7 13.104 7 12ZM9 17C7.896 17 7 17.896 7 19C7 20.104 7.896 21 9 21C10.104 21 11 20.104 11 19C11 17.896 10.104 17 9 17ZM13 19C13 17.896 13.896 17 15 17C16.104 17 17 17.896 17 19C17 20.104 16.104 21 15 21C13.896 21 13 20.104 13 19ZM15 10C13.896 10 13 10.896 13 12C13 13.104 13.896 14 15 14C16.104 14 17 13.104 17 12C17 10.896 16.104 10 15 10ZM17 5C17 6.104 16.104 7 15 7C13.896 7 13 6.104 13 5C13 3.896 13.896 3 15 3C16.104 3 17 3.896 17 5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicator);
export default __webpack_public_path__ + "static/media/drag-indicator.a77ec9eb57f279d80bd23516f32beddd.svg";
export { ForwardRef as ReactComponent };